import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { registerSW } from 'virtual:pwa-register';
import App from './App';
import './styles.css';

/**
 * Service worker registration.
 *
 * `registerType: 'prompt'` means an update never swaps content out from under
 * the user mid-comparison — we reload only on an explicit confirmation.
 */
const updateSW = registerSW({
  onNeedRefresh() {
    if (window.confirm('A new version of KcalTrack is available. Reload now?')) {
      void updateSW(true);
    }
  },
});

const container = document.getElementById('root');
if (container === null) throw new Error('Root element #root not found');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
